<template>
  <score-main @back="goBack">
    <template slot="nav">
      <div class="scoreNav">
        <p v-if="showData">
          <span v-if="classInfo.is_special_train === 1"> 【快】 </span>
          {{ classInfo.name }}
          <span v-if="classInfo.experiment && (['super','system'].includes(member_type))" style="color:#f88594;">&nbsp;[试]</span>
        </p>
        <div v-if="isShowClassInfo" class="btns">
          <div class="btn" @click="lookClassDetail">培训班</div>
          <div
              class="btn"
              @click="lookScore"
              v-if="classInfo.class_train_type === 'train'||classInfo.class_train_type === 'physical_train' ||classInfo.class_train_type === 'goalkeeper_train'"
          >
            问卷调查
          </div>
          <div v-if="isShowComplaint > 0" class="btn" @click="showfeeback('complaint',0)">投诉</div>
          <div v-if="isShowAppeal > 0" class="btn" @click="showfeeback('appeal',1)">申诉</div>
          <div v-if="isShowOther > 0" class="btn" @click="showfeeback('other',2)">反馈</div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="scoreMain">
        <div class="mainUp">
          <template v-if="showData">
            <div class="upCommon">
              <div class="imgWrap" @click="greetMoment">
                <img
                  :src="classInfo.moment_picture || imgSrc"
                  @error="classImgError"
                  alt=""
                />
                <div class="pos">
                  <yioks-status
                    class="status"
                    :status="classInfo.status"
                  ></yioks-status>
                  <div class="btnWrap">
                    <div class="btn">精彩瞬间</div>
                  </div>
                </div>
              </div>
              <div class="details">
                <p>
                  培训日期：{{ classInfo.start_date | time(false) }} 至
                  {{ classInfo.end_date | time(false) }}
                </p>
                <p>训练场地：{{ classInfo.training_address }}</p>
                <p>理论课场地：{{ classInfo.theory_address }}</p>
                <div class="teacherWrap">
                  <template v-if="isShowClassInfo">
                    <div style="display:flex">
                      <p class="teacherName">
                        <span>主讲师：</span>
                        <span
                          v-if="classInfo.teacher_off_name"
                          class="link"
                          @click="lookTeaDetail(classInfo.teacher_off_ids)"
                        >{{ classInfo.teacher_off_name }}</span
                        >
                        <span v-else>足协指派</span>
                      </p>
                      <p v-if="classInfo.teacher_name">
                        <span>助理讲师：</span>
                        <span
                          class="link"
                          v-for="(item, index) in assistant.name"
                          :key="index"
                          @click="lookTeaDetail(assistant.ids[index])"
                        >{{
                          item +
                          (index == assistant.name.length - 1 ? "" : "，")
                        }}</span
                        >
                      </p>
                    </div>
                    <div v-if="classInfo.teacher_zhuli_names">
                      <p  style="margin-top:4px">
                        <span>讲师助理：</span>
                        <span
                          class="link"
                          v-for="(item, index) in teacher_zhuli.name"
                          :key="index"
                          @click="lookOver(teacher_zhuli.ids[index])"
                        >{{
                      item +
                      (index == teacher_zhuli.name.length - 1 ? "" : "，")
                    }}</span
                        >
                      </p>
                    </div>
                  </template>
                  
                  <template v-else>
                    <div style="display:flex">
                      <p class="teacherName">
                        <span>主讲师：</span>
                        <span>{{
                        classInfo.teacher_off_name || "足协指派"
                      }}</span>
                      </p>
                      <p v-if="classInfo.teacher_name">
                        <span>助理讲师：</span>
                        <span>{{ classInfo.teacher_name }}</span>
                      </p>
                    </div>
                    <div v-if="classInfo.teacher_zhuli_names">
                      <p  style="margin-top:4px">
                        <span>讲师助理：</span>
                        <span>{{ classInfo.teacher_zhuli_names }}</span>
                      </p>
                    </div>
                  </template>
                </div>
                <div style="display: flex">
                  <div class="service-item" v-if="classInfo.class_qr_code">
                    <div style="display: flex; vertical-align: middle">
                      <span style="margin-right: 10px">班级群二维码:</span>
                      <v-icon
                        name="qrcode"
                        scale="1.15"
                        style="color: #4cd964"
                      ></v-icon>
                    </div>
                    <div class="item-common qrCode">
                      <div class="content">
                        <img :src="classInfo.class_qr_code" alt="" />
                      </div>
                    </div>
                  </div>
                  <template
                    v-if="classInfo.class_train_type === 'continue_education'"
                  >
                    <p>学时：{{ classInfo.hours || "--" }}</p>
                  </template>
                </div>
              </div>
            </div>
            <div class="scheduleWrap">
              <div
                class="edti_box"
                v-if="isShowAuditScore || isShowDownload"
              >
                <template
                  v-if="
                    classInfo.class_train_type === 'teacher_train' ||
                    classInfo.class_train_type === 'goalkeeper_education'
                  "
                >
                  <div
                    v-if="isShowAuditScore"
                    class="btn"
                    style="background-color: #b2b2b2; cursor: no-drop"
                  >
                    审核成绩
                  </div>
                </template>
                <template v-else>
                  <div v-if="isShowAuditScore" class="btn" @click="verifyScore">
                    审核成绩
                  </div>
                </template>
                <!--<div v-if="isShowEditScore" class="btn" @click="editScore">-->
                  <!--编辑成绩-->
                <!--</div>-->
                <button
                  type="button"
                  :disabled="loadScore"
                  v-if="isShowDownload"
                  class="btn"
                  @click="downScore"
                >
                  下载成绩
                </button>
              </div>
              <div class="schedule">
                <div class="btnWrap">
                  <p>课程表：</p>
                  <div class="btn check" @click="showSchedule">查看</div>
                  <a
                    class="btn download"
                    :href="
                      !classInfo.timetable_picture
                        ? ScheduleImg
                        : classInfo.timetable_picture
                    "
                    download=""
                    >下载</a
                  >
                </div>
              </div>
              <yioks-schedule
                :flag="scheduleFlag"
                :dw="'900px'"
                :level="classInfo.class_level"
                :class_train_type="classInfo.class_train_type"
                :pic.sync="classInfo.timetable_picture"
                @hide="hideSchedule($event)"
              ></yioks-schedule>
            </div>
          </template>
        </div>
        <div class="mainDown">
          <template v-if="showData">
            <vue-scroll :ops="ops">
              <div class="contentWrap">
                <div class="content">
                  <div class="itemWrap" v-if="isShowScoreMsg">
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="regular/clock"
                          scale="1.5"
                        ></v-icon>
                        <p>成绩审核过程</p>
                      </div>
                    </div>
                    <div class="timeline">
                      <div
                        class="timeline-item"
                        v-for="(audit, i) in scoreMsg"
                        :key="audit.audit_id"
                      >
                        <div
                          class="item_tail"
                          v-show="i !== scoreMsg.length - 1"
                        ></div>
                        <div
                          class="item_node"
                          v-if="audit.type === 'audit_score'"
                        >
                          {{ audit.status | translate }}
                        </div>
                        <div class="item_node" v-else>
                          {{ audit.type === "save_score" ? "风险" : "提交" }}
                        </div>
                        <div class="item_wrap">
                          <div class="timestamp">
                            <span>{{ audit.create_time | time }}</span>
                            <span
                              class="audit_people"
                              v-if="audit.type === 'audit_score'"
                            >
                              审核人：{{ audit.unit_name | parseUnitName }}（{{
                                audit.user_name
                              }}）
                            </span>
                            <span class="audit_people" v-else>
                              提交人：{{ audit.user_name }}
                            </span>
                          </div>
                          <div class="item_cont">
                            <p>
                              <span>
                                {{ audit.type | transType(isFive) }}
                              </span>
                              <span v-if="audit.type === 'audit_score'">
                                ：{{ audit.status | translate }}
                              </span>
                            </p>
                            <p
                              v-if="
                                audit.type !== 'submit_score' &&
                                audit.opinion &&
                                audit.type !== 'save_score'
                              "
                            >
                              理由 ：{{ audit.opinion }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="itemWrap">
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-bar"
                          scale="1.6"
                        ></v-icon>
                        <p>成绩统计</p>
                      </div>
                    </div>
                    <div
                      v-if="isFive && classInfo.class_level === 'early'"
                      class="totalScore"
                      style="border-bottom: 1px solid #fff"
                    >
                      <div class="item">
                        <p>
                          <span
                            >学员人数：{{
                              scoreNum.fail_num +
                              scoreNum.pass_numA +
                              scoreNum.pass_numB +
                              scoreNum.pass_numC+
                              scoreNum.semi_pass_num
                            }}人</span
                          >
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>推荐L1：{{ scoreNum.pass_numA }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>实践补考：{{ scoreNum.pass_numB }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>仅限初级：{{ scoreNum.pass_numC }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>未通过：{{ scoreNum.fail_num }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>预通过：{{ scoreNum.semi_pass_num }}人</span>
                        </p>
                      </div>
                    </div>
                    <div
                      v-else
                      class="totalScore"
                      style="border-bottom: 1px solid #fff"
                    >
                      <div class="item">
                        <p>
                          <span
                            >学员人数：{{
                              scoreNum.fail_num +
                              scoreNum.pass_num +
                              scoreNum.practice_make_up +
                              scoreNum.semi_pass_num
                            }}人</span
                          >
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>通过：{{ scoreNum.pass_num }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>未通过：{{ scoreNum.fail_num }}人</span>
                        </p>
                      </div>
                      <div class="item" v-if="scoreNum.practice_make_up">
                        <p>
                          <span
                            >实践考试补考：{{
                              scoreNum.practice_make_up
                            }}人</span
                          >
                        </p>
                      </div>
                      <div class="item" v-if="isFive">
                        <p>
                          <span
                            >预通过：{{
                              scoreNum.semi_pass_num
                            }}人</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="itemWrap" v-if="!isFive && ['super','system'].includes(member_type)">
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-bar"
                          scale="1.6"
                        ></v-icon>
                        <p>学员信息统计</p>
                      </div>
                    </div>
                    <div
                      class="totalScore"
                      style="border-bottom: 1px solid #fff"
                    >
                      <div class="item">
                        <p>
                          <span>审核通过：{{ infoStatus.passNum }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>待审核：{{ infoStatus.auditNum }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>退回修改：{{ infoStatus.refusedNum }}人</span>
                        </p>
                      </div>
                      <div class="item">
                        <p>
                          <span>未填写：{{ infoStatus.noActiveNum }}人</span>
                        </p>
                      </div>
                    </div>
  
                  </div>
                  <div class="itemWrap">
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-line"
                          scale="1.6"
                        ></v-icon>
                        <p>成绩信息</p>
                      </div>
                      <template v-if="['super','system'].includes(member_type)">
                        <!--<div v-if="!isFive" style="font-size:15px;">-->
                          <!--<span>通过：{{infoStatus.passNum}}人</span>-->
                          <!--<span style="margin-left:15px">待审核：{{infoStatus.auditNum}}人</span>-->
                          <!--<span style="margin-left:15px">退回修改：{{infoStatus.refusedNum}}人</span>-->
                          <!--<span style="margin-left:15px">未填写：{{infoStatus.noActiveNum}}人</span>-->
                        <!--</div>-->
                        <div v-if="!isFive && ['ScoreAudit','ScoreRefused'].includes(classInfo.status)" style="font-size:15px;color:#4CD964;border-bottom: 1px solid #4CD964;cursor:pointer" @click="goConfirmInfo">
                          培训班学员信息审核>>
                        </div>
                      </template>
                    </div>

                    <div class="tips" v-if="isFive && classInfo.class_level === 'early'">
                      <div class="five-tips">
                        <span class="tips-item">考试成绩：</span>
                        <span class="tips-item">理论：60 通过；</span>
                        <span class="tips-item">实践：70 通过。</span>
                      </div>
                      <div class="five-tips">
                        <span class="tips-item">实践考核评分标准：</span>
                        <span class="tips-item"
                          >通过（A）【推荐L1】：80以上；</span
                        >
                        <span class="tips-item"
                          >通过（B）【实践补考】：75-79；</span
                        >
                        <span class="tips-item"
                          >通过（C）【仅限初级】：70-74；</span
                        >
                        <span class="tips-item">未通过：70以下。</span>
                      </div>
                    </div>
                    <div class="tips" v-if="isFive && classInfo.class_level === 'L1'">
                      <div class="five-tips">
                        <span class="tips-item">考试成绩：</span>
                        <span class="tips-item">实践：70 通过；</span>
                        <span class="tips-item">理论：60 通过；</span>
                        <span class="tips-item">规则：60 通过。</span>
                      </div>
                    </div>
                    <div class="tips" v-if="isFive && ['L2','L3'].includes(classInfo.class_level)">
                      <div class="five-tips">
                        <span class="tips-item">考试成绩：</span>
                        <span class="tips-item">实践：70 通过；</span>
                        <span class="tips-item">理论：60 通过；</span>
                      </div>
                    </div>
                    <div class="table">
                      <div v-for="(item, index) in student_data" :key="index">
                        <div
                          :class="{
                            item: true,
                            repetition_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '0',
                            unusual_err_stu:
                              item.is_score_unusual_stu == '1' &&
                              item.is_repetition_stu == '0',
                            both_err_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '1',
                          }"
                          :title="
                            item.is_score_unusual_stu
                              | tipMsg(
                                item.is_repetition_stu,
                                item.is_not_score_stu
                              )
                          "
                        >
                          <div class="row up">
                            <div class="col user">
                              <div
                                class="imgWrap"
                                @click="viewDetail(item.uid)"
                              >
                                <img
                                  :src="item.profile_picture || User"
                                  alt=""
                                  @error="userImgError(index)"
                                />
                              </div>
                              <template v-if="classInfo.class_train_type === 'continue_education'">
                                <div class="wrap">
                                  <p class="name">{{ item.user_name }}</p>
                                  <!--200 是教案考核 -->
                                  <template v-if="classInfo.examine_way.includes('200')">
                                    <template v-if="!showHistory">
                                      <div class="btn" v-if="item.plan_id">

                                        <router-link
                                          target="_blank"
                                          :to="{
                                      path: 'tutorial_detail',
                                      query: { id: item.plan_id},
                                    }"
                                        >
                                          查看教案
                                        </router-link>
                                      </div>
                                      <div  class="nonePlan" v-else>
                                        无考试教案
                                      </div>
                                    </template>
                                    <template v-else>
                                      <div class="btn_route" >
                                        <p class="route tutorial" v-if="item.plan_id">
                                          <router-link
                                            target="_blank"
                                            :to="{
                                        path: 'tutorial_detail',
                                        query: {
                                          id: item.plan_id
                                        },
                                      }"
                                          >
                                            查看教案
                                          </router-link>
                                        </p>
                                        <p class="tutorial" v-else>
                                          <span>无考试教案</span>
                                        </p>
                                        <p class="split">/</p>
                                        <p class="route history">
                                          <router-link
                                            target="_blank"
                                            :to="{
                                        path: 'tran_his',
                                        query: { u_id: item.uid },
                                      }"
                                          >
                                            历程
                                          </router-link>
                                        </p>
                                      </div>
                                    </template>
                                  </template>
                                  <template v-else>
                                    <div class="btn" v-if="!showHistory">
                                      <router-link
                                        target="_blank"
                                        :to="{
                                      path: 'stu_tutorial',
                                      query: { user_id: item.uid, c_id: c_id },
                                    }"
                                      >
                                        查看教案
                                      </router-link>
                                    </div>
                                    <div class="btn_route" v-else>
                                      <p class="route tutorial">
                                        <router-link
                                          target="_blank"
                                          :to="{
                                        path: 'stu_tutorial',
                                        query: {
                                          user_id: item.uid,
                                          c_id: c_id,
                                        },
                                      }"
                                        >
                                          教案
                                        </router-link>
                                      </p>
                                      <p class="split">/</p>
                                      <p class="route history">
                                        <router-link
                                          target="_blank"
                                          :to="{
                                        path: 'tran_his',
                                        query: { u_id: item.uid },
                                      }"
                                        >
                                          历程
                                        </router-link>
                                      </p>
                                    </div>
                                  </template>
                                </div>
                              </template>
                              <template v-else>
                                <div class="wrap">
                                  <p class="name">{{ item.user_name }}</p>
                                  <div class="btn" v-if="!showHistory">
                                    <router-link
                                      target="_blank"
                                      :to="{
                                      path: 'stu_tutorial',
                                      query: { user_id: item.uid, c_id: c_id },
                                    }"
                                    >
                                      查看教案
                                    </router-link>
                                  </div>
                                  <div class="btn_route" v-else>
                                    <p class="route tutorial">
                                      <router-link
                                        target="_blank"
                                        :to="{
                                        path: 'stu_tutorial',
                                        query: {
                                          user_id: item.uid,
                                          c_id: c_id,
                                        },
                                      }"
                                      >
                                        教案
                                      </router-link>
                                    </p>
                                    <p class="split">/</p>
                                    <p class="route history">
                                      <router-link
                                        target="_blank"
                                        :to="{
                                        path: 'tran_his',
                                        query: { u_id: item.uid },
                                      }"
                                      >
                                        历程
                                      </router-link>
                                    </p>
                                  </div>
                                </div>
                              </template>

                            </div>
                            <div class="col info">
                              <div class="title">
                                <p>基</p>
                                <p>本</p>
                                <p>信</p>
                                <p>息</p>
                              </div>
                              <div class="block">
                                <div class="line">
                                  <p>证件号 : {{ item.id_number }}</p>
                                </div>
                                <div class="line">
                                  <p>
                                    <span
                                      >性别 :
                                      {{ item.gender | getGender }}</span
                                    >
                                    <span>手机 : {{ item.mobile_phone }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col note">
                              <div class="title">
                                <template v-if="isFive">
                                  <p>综</p>
                                  <p>合</p>
                                  <p>评</p>
                                  <p>价</p>
                                </template>
                                <template v-else>
                                  <p>备</p>
                                  <p>注</p>
                                </template>
                              </div>
                              <textarea
                                v-model="item.ability_remark"
                                placeholder="暂无备注"
                                disabled
                              ></textarea>
                            </div>
                            <div
                              class="col average"
                              v-if="item.enroll_type === 'common'"
                            >
                              <div class="title" style="height: 100%;">
                                <p>综合</p>
                                <p v-if="zonghe">平均</p>
                                <p>成绩</p>
                              </div>
                              <div class="score">
                                <p>{{ item.practice_avg_points || "--" }}</p>
                              </div>
                            </div>
                            <div class="col grade">
                              <div class="title">
                                <p>成</p>
                                <p>绩</p>
                              </div>
                              <div class="gradeStatus">
                                <p>
                                  {{ item.results_status | getScore }}
                                  <span
                                    v-if="
                                      ['A', 'B', 'C','PRO'].includes(
                                        item.results_level
                                      )
                                    "
                                    >({{
                                      item.results_level | resLevel(isFive)
                                    }})</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row down"
                            v-if="item.scoreArr.length>0"
                          >
                            <div
                              class="col"
                              v-for="(col, index) in item.scoreArr"
                              :key="index"
                            >
                              <span>{{ col.achievement_subject_des }}</span>
                              <p
                                v-if=" ![30, 45, 46,54,67,68,69, 200,73,78].includes(col.achievement_subject_id)"
                              >
                                {{ col.achievement_score }}分
                              </p>
                              <p v-else>{{ col.achievement_score }}</p>
                            </div>
                            <div
                              class="col"
                              v-if="(classInfo.class_level === 'D'||classInfo.class_level === 'C') && classInfo.class_train_type === 'train'"
                            >
                              <span>综合</span>
                              <p>{{ item.total_points }}分</p>
                            </div>
                          </div>
                          <div class="row down" v-if="isFive">
                            <div class="col" v-if="student_achievement_file_data.length > 0">
                              <span
                                class="flex-wrapper"
                                v-if="item.document_title && item.document_url"
                              >理论考试答卷：
                                <a
                                  class="link-doc suc"
                                  :href="item.document_url"
                                  :title="item.document_title"
                                  target="_blank"
                                >{{ item.document_title }}</a
                                >
                              </span>
                              <span class="flex-wrapper" v-else
                              >未考试原因：{{ item.reason || "--" }}</span
                              >
                            </div>
                            <div class="col" v-else>
                              <span class="flex-wrapper">2022年5月10日前的培训班不支持上传理论课答卷功能</span>
                            </div>
                          </div>
                          <template v-if="['L1','L2','L3'].includes(classInfo.class_level) && classInfo.class_train_type === 'train' && item.results_status === 'pass'">
                            <div class="row down" v-if="item.certificate_number">
                              <div class="col" >
                              <span class="flex-wrapper" style="" >证书编号：{{item.certificate_number}} <a
                                target="_blank"   :href="item.ducoment_address" style="color:#4CD964" v-if="item.ducoment_address">（查看电子证书）</a><span  style="cursor: pointer; color: #f88594;" @click="addFunc(item,index)" v-if="classInfo.status === 'ScoreAudit' && ['supFive','sysFive'].includes(member_type)"> / 编辑证书编号>></span></span>
                                
                              </div>
                            </div>
                            <div class="row down" v-if="classInfo.status === 'ScoreAudit' && ['supFive','sysFive'].includes(member_type) && !item.certificate_number">
                              <div class="col">
                                <span class="flex-wrapper" style="cursor: pointer; color: #f88594; font-size: 16px" @click="addFunc(item,index)">点击录入证书编号>></span>
                              </div>
                            </div>
                          </template>
                          <div class="row down" v-if="!isFive && ['super','system'].includes(member_type)">
                            <div class="col">
                              <span
                                class="flex-wrapper"
                              >信息审核状态：{{item.info_status |auditStatus}}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="itemWrap"
                    v-if="
                      (classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train' ) &&
                      ['A', 'B','PRO','F1','F2'].includes(classInfo.class_level) &&
                      make_up_student_data.length
                    "
                  >
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-bar"
                          scale="1.6"
                        ></v-icon>
                        <p>实践补考成绩统计</p>
                      </div>
                    </div>
                    <div class="totalScore">
                      <div
                        class="item"
                        v-if="
                          scoreNum.pass_num_make_up_exam !== undefined &&
                          scoreNum.fail_num_make_up_exam !== undefined
                        "
                      >
                        <p>
                          <span
                            >实践考试补考总人数：{{
                              Number(
                                scoreNum.pass_num_make_up_exam +
                                  scoreNum.fail_num_make_up_exam
                              ) || 0
                            }}人</span
                          >
                        </p>
                      </div>
                      <div
                        class="item"
                        v-if="scoreNum.pass_num_make_up_exam !== undefined"
                      >
                        <p>
                          <span
                            >实践考试补考通过：{{
                              scoreNum.pass_num_make_up_exam
                            }}人</span
                          >
                        </p>
                      </div>
                      <div
                        class="item"
                        v-if="scoreNum.fail_num_make_up_exam !== undefined"
                      >
                        <p>
                          <span
                            >实践考试补考未通过：{{
                              scoreNum.fail_num_make_up_exam
                            }}人</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="itemWrap"
                    v-if="
                      (classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train' ) &&
                      ['A', 'B','PRO','F1','F2'].includes(classInfo.class_level) &&
                      make_up_student_data.length
                    "
                  >
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-line"
                          scale="1.6"
                        ></v-icon>
                        <p>实践补考成绩信息</p>
                      </div>
                    </div>
                    <div class="table">
                      <div
                        v-for="(item, index) in make_up_student_data"
                        :key="`make_up_student_data-${index}`"
                      >
                        <div
                          :class="{
                            item: true,
                            repetition_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '0',
                            unusual_err_stu:
                              item.is_score_unusual_stu == '1' &&
                              item.is_repetition_stu == '0',
                            both_err_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '1',
                          }"
                          :title="
                            item.is_score_unusual_stu
                              | tipMsg(
                                item.is_repetition_stu,
                                item.is_not_score_stu
                              )
                          "
                        >
                          <div class="row up">
                            <div class="col user">
                              <div
                                class="imgWrap"
                                @click="viewDetail(item.uid)"
                              >
                                <img
                                  :src="item.profile_picture || User"
                                  alt=""
                                  @error="
                                    userImgErrorMakeUp(
                                      index,
                                      make_up_student_data
                                    )
                                  "
                                />
                              </div>
                              <div class="wrap">
                                <p class="name">{{ item.user_name }}</p>
                                <div class="btn" v-if="!showHistory">
                                  <router-link
                                    target="_blank"
                                    :to="{
                                      path: 'stu_tutorial',
                                      query: { user_id: item.uid, c_id: c_id },
                                    }"
                                  >
                                    查看教案
                                  </router-link>
                                </div>
                                <div class="btn_route" v-else>
                                  <p class="route tutorial">
                                    <router-link
                                      target="_blank"
                                      :to="{
                                        path: 'stu_tutorial',
                                        query: {
                                          user_id: item.uid,
                                          c_id: c_id,
                                        },
                                      }"
                                    >
                                      教案
                                    </router-link>
                                  </p>
                                  <p class="split">/</p>
                                  <p class="route history">
                                    <router-link
                                      target="_blank"
                                      :to="{
                                        path: 'tran_his',
                                        query: { u_id: item.uid },
                                      }"
                                    >
                                      历程
                                    </router-link>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col info">
                              <div class="title">
                                <p>基</p>
                                <p>本</p>
                                <p>信</p>
                                <p>息</p>
                              </div>
                              <div class="block">
                                <div class="line">
                                  <p>证件号 : {{ item.id_number }}</p>
                                </div>
                                <div class="line">
                                  <p>
                                    <span
                                      >性别 :
                                      {{ item.gender | getGender }}</span
                                    >
                                    <span>手机 : {{ item.mobile_phone }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col note">
                              <div class="title">
                                <template v-if="isFive">
                                  <p>综</p>
                                  <p>合</p>
                                  <p>评</p>
                                  <p>价</p>
                                </template>
                                <template v-else>
                                  <p>备</p>
                                  <p>注</p>
                                </template>
                              </div>
                              <textarea
                                v-model="item.ability_remark"
                                placeholder="暂无备注"
                                disabled
                              ></textarea>
                            </div>
                            <div
                              class="col average"
                              v-if="item.enroll_type === 'common'"
                            >
                              <div class="title"  style="height: 100%;">
                                <p>综合</p>
                                <p v-if="zonghe">平均</p>
                                <p>成绩</p>
                              </div>
                              <div class="score">
                                <p>{{ item.practice_avg_points || "--" }}</p>
                              </div>
                            </div>
                            <div class="col grade">
                              <div class="title">
                                <p>成</p>
                                <p>绩</p>
                              </div>
                              <div class="gradeStatus">
                                <p>
                                  {{ item.results_status | getScore }}
                                  <span
                                    v-if="
                                      ['A', 'B', 'C','PRO','F1','F2'].includes(
                                        item.results_level
                                      )
                                    "
                                    >({{
                                      item.results_level | resLevel(isFive)
                                    }})</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row down"
                            v-if="classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train'"
                          >
                            <div class="col" v-for="col in item.scoreArr">
                              <span>{{ col.achievement_subject_des }}</span>
                              <p
                                v-if="
                                  col.achievement_subject_des !== '踢球能力*' &&
                                  col.achievement_subject_des !== '运动能力*' &&
                                  col.achievement_subject_des !== '演讲能力*'
                                "
                              >
                                {{ col.achievement_score }}分
                              </p>
                              <p v-else>{{ col.achievement_score }}</p>
                            </div>
                            <div
                              class="col"
                              v-if="classInfo.class_level === 'D'"
                            >
                              <span>综合</span>
                              <p>{{ item.total_points }}分</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="itemWrap"
                    v-if="semi_pass_student_data.length"
                  >
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-bar"
                          scale="1.6"
                        ></v-icon>
                        <p>理论补考成绩统计</p>
                      </div>
                    </div>
                    <div class="totalScore">
                      <div
                        class="item"
                        v-if="
                          scoreNum.pass_num_make_up_exam !== undefined &&
                          scoreNum.fail_num_make_up_exam !== undefined
                        "
                      >
                        <p>
                          <span
                          >理论考试补考总人数：{{
                              Number(
                                scoreNum.pass_num_make_up_exam +
                                  scoreNum.fail_num_make_up_exam
                              ) || 0
                            }}人</span
                          >
                        </p>
                      </div>
                      <div
                        class="item"
                        v-if="scoreNum.pass_num_make_up_exam !== undefined"
                      >
                        <p>
                          <span
                          >理论考试补考通过：{{
                              scoreNum.pass_num_make_up_exam
                            }}人</span
                          >
                        </p>
                      </div>
                      <div
                        class="item"
                        v-if="scoreNum.fail_num_make_up_exam !== undefined"
                      >
                        <p>
                          <span
                          >理论考试补考未通过：{{
                              scoreNum.fail_num_make_up_exam
                            }}人</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="itemWrap"
                    v-if="semi_pass_student_data.length"
                  >
                    <div class="titleWrap">
                      <div class="title">
                        <v-icon
                          class="logo"
                          name="chart-line"
                          scale="1.6"
                        ></v-icon>
                        <p>理论补考成绩信息</p>
                      </div>
                    </div>
                    <div class="table">
                      <div
                        v-for="(item, index) in semi_pass_student_data"
                        :key="`semi_pass_student_data-${index}`"
                      >
                        <div
                          :class="{
                            item: true,
                            repetition_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '0',
                            unusual_err_stu:
                              item.is_score_unusual_stu == '1' &&
                              item.is_repetition_stu == '0',
                            both_err_stu:
                              item.is_repetition_stu == '1' &&
                              item.is_score_unusual_stu == '1',
                          }"
                          :title="
                            item.is_score_unusual_stu
                              | tipMsg(
                                item.is_repetition_stu,
                                item.is_not_score_stu
                              )
                          "
                        >
                          <div class="row up">
                            <div class="col user">
                              <div
                                class="imgWrap"
                                @click="viewDetail(item.uid)"
                              >
                                <img
                                  :src="item.profile_picture || User"
                                  alt=""
                                  @error="
                                    userImgErrorMakeUp(
                                      index,
                                      semi_pass_student_data
                                    )
                                  "
                                />
                              </div>
                              <div class="wrap">
                                <p class="name">{{ item.user_name }}</p>
                                <div class="btn" v-if="!showHistory">
                                  <router-link
                                    target="_blank"
                                    :to="{
                                      path: 'stu_tutorial',
                                      query: { user_id: item.uid, c_id: c_id },
                                    }"
                                  >
                                    查看教案
                                  </router-link>
                                </div>
                                <div class="btn_route" v-else>
                                  <p class="route tutorial">
                                    <router-link
                                      target="_blank"
                                      :to="{
                                        path: 'stu_tutorial',
                                        query: {
                                          user_id: item.uid,
                                          c_id: c_id,
                                        },
                                      }"
                                    >
                                      教案
                                    </router-link>
                                  </p>
                                  <p class="split">/</p>
                                  <p class="route history">
                                    <router-link
                                      target="_blank"
                                      :to="{
                                        path: 'tran_his',
                                        query: { u_id: item.uid },
                                      }"
                                    >
                                      历程
                                    </router-link>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col info">
                              <div class="title">
                                <p>基</p>
                                <p>本</p>
                                <p>信</p>
                                <p>息</p>
                              </div>
                              <div class="block">
                                <div class="line">
                                  <p>证件号 : {{ item.id_number }}</p>
                                </div>
                                <div class="line">
                                  <p>
                                    <span
                                    >性别 :
                                      {{ item.gender | getGender }}</span
                                    >
                                    <span>手机 : {{ item.mobile_phone }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="col note">
                              <div class="title">
                                <template v-if="isFive">
                                  <p>综</p>
                                  <p>合</p>
                                  <p>评</p>
                                  <p>价</p>
                                </template>
                                <template v-else>
                                  <p>备</p>
                                  <p>注</p>
                                </template>
                              </div>
                              <textarea
                                v-model="item.ability_remark"
                                placeholder="暂无备注"
                                disabled
                              ></textarea>
                            </div>
                            <div
                              class="col average"
                              v-if="item.enroll_type === 'common'"
                            >
                              <div class="title"  style="height: 100%;">
                                <p>综合</p>
                                <p v-if="zonghe">平均</p>
                                <p>成绩</p>
                              </div>
                              <div class="score">
                                <p>{{ item.practice_avg_points || "--" }}</p>
                              </div>
                            </div>
                            <div class="col grade">
                              <div class="title">
                                <p>成</p>
                                <p>绩</p>
                              </div>
                              <div class="gradeStatus">
                                <p>
                                  {{ item.results_status | getScore }}
                                  <span
                                    v-if="
                                      ['A', 'B', 'C','PRO','F1','F2'].includes(
                                        item.results_level
                                      )
                                    "
                                  >({{
                                      item.results_level | resLevel(isFive)
                                    }})</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row down"
                            v-if="classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train'"
                          >
                            <div class="col" v-for="col in item.scoreArr">
                              <span>{{ col.achievement_subject_des }}</span>
                              <p
                                v-if="
                                  col.achievement_subject_des !== '踢球能力*' &&
                                  col.achievement_subject_des !== '运动能力*' &&
                                  col.achievement_subject_des !== '演讲能力*'
                                "
                              >
                                {{ col.achievement_score }}分
                              </p>
                              <p v-else>{{ col.achievement_score }}</p>
                            </div>
                            <div
                              class="col"
                              v-if="classInfo.class_level === 'D'"
                            >
                              <span>综合</span>
                              <p>{{ item.total_points }}分</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <template >
                    <div class="itemWrap">
                      <div class="titleWrap">
                        <div class="title">
                          <v-icon
                            class="logo"
                            name="chart-line"
                            scale="1.6"
                          ></v-icon>
                          <p>主讲师培训班报告</p>
                          <div v-for="col in reportAssistant">
                            <div class="btn" @click="showClassDetail = true , showTeacherId=col.author_id">{{col.name}}培训班报告</div>
                          </div>
                        </div>
                      </div>
                      <class-report-view
                        :report="classReportData"
                        :isHighClass="isHighClass"
                        :classTrainType="classInfo.class_train_type"
                      ></class-report-view>
                    </div>
                    <div class="itemWrap" v-if="studentFail.length">
                      <div class="titleWrap">
                        <div class="title">
                          <v-icon
                            class="logo"
                            name="chart-line"
                            scale="1.6"
                          ></v-icon>
                          <p>学员培训未通过<span v-if="!['D','C','early','GC'].includes(classInfo.class_level)">或补考</span>详细原因</p>
                        </div>
                      </div>
                      <div class="info-view">
                        <div class="table">
                          <el-row
                            class="report-row"
                            v-for="(item, index) in studentFail"
                          >
                            <el-col class="report-col" :span="4" style="border-right:none">
                              <p></p>{{ item.name }}
                              <p style="color:#f88594;font-size:14px">({{item.results_status === 'practice_make_up' ? '实践考试补考' : '未通过'}})</p>
                            </el-col>
                            <el-col class="report-col" :span="20" style="border-left:1px solid white;min-height:63px">{{
                              item.reason_info || "--"
                            }}</el-col>
                          </el-row>
                        </div>
                      </div>
                    </div>
                    <div class="itemWrap" v-if="teaEvaData.length">
                      <div class="titleWrap">
                        <div class="title">
                          <v-icon
                            class="logo"
                            name="chart-line"
                            scale="1.6"
                          ></v-icon>
                          <p>助理讲师评价表</p>
                        </div>
                      </div>
                      <teacher-eva-view
                        :eva.sync="teaEvaData"
                      ></teacher-eva-view>
                    </div>
                  </template>
                </div>
              </div>
            </vue-scroll>
          </template>
        </div>
        <yioks-verify
          :flag="verifyFlag"
          :verifyBtn="true"
          :holderText="`如审核拒绝，可在此输入理由`"
          @hideVerify="hideVerifyDialog"
        ></yioks-verify>
        <el-dialog
          class="detail-info-dia"
          title="详细信息"
          :visible.sync="ifDiaShow"
          :close-on-click-modal="false"
          width="750px"
          top="12vh"
        >
          <div class="scroll-wrap">
            <vue-scroll :ops="disScrollOpt" ref="vScroll">
              <div class="stu-info-box">
                <stu-detail-info :uid="stuUid" :cid="c_id"></stu-detail-info>
              </div>
            </vue-scroll>
          </div>
        </el-dialog>
        <report-info-detail
          v-if="showClassDetail"
          :isShow.sync="showClassDetail"
          :c_id="classInfo.c_id"
          :showClassLevel="classInfo.class_level"
          :user_id="showTeacherId"
          :classTrainType="classInfo.class_train_type"
        ></report-info-detail>
        <template v-if="add_show">
          <add-dialog :showAddDialog="add_show" :Info="certificateInfo" @hideTips="hideAddDocumentTips"></add-dialog>
        </template>
      </div>
    </template>
  </score-main>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import User from "@/assets/images/person.png";
import Img from "@/assets/images/class_logo.png";
import ScheduleImg from "@/assets/images/timetable/class_d.png";
import { scoreDetail, scoreDownload } from "@/api/common/api";
import "vue-awesome/icons/chart-bar";
import "vue-awesome/icons/chart-line";
import "vue-awesome/icons/regular/envelope";
import "vue-awesome/icons/regular/clock";
import { classScoreVerify } from "@/api/system_manager/api";
import commonFun from "@/assets/js/yioks";
import { roleHash } from "@/assets/js/status";
import fiveMixins from "@/minix/fiveMixins";
const { downfile } = commonFun;
import { storageData } from "@/assets/js/storage";

// const filterHash = {
//   "excellence": "优",
//   "good": "良",
//   "general": "一般",
//   "poor": "差",
//   "pass": "通过",
//   "fail": "未通过",
//   "repulse": "拒绝"
// };

const filterHash = {
  pass: "通过",
  wait: "待审核",
  repulse: "拒绝",
  pause: "暂停",
};
const filterType = {
  approve: "审核培训班",
  adjust: "调整学员名单",
  audit_score: "审核成绩",
  submit_class: "提交培训班",
  submit_score: "提交成绩",
  save_score: "激活成绩编辑功能（风险提示）",
};

const filterTypeFive = {
  approve: "审核五人制培训班",
  adjust: "调整学员名单",
  audit_score: "审核五人制成绩",
  submit_class: "提交五人制培训班",
  submit_score: "提交五人制成绩",
  save_score: "激活成绩编辑功能（风险提示）",
};
export default {
  name: "score-detail",
  mixins: [fiveMixins],
  data() {
    const member_type = storageData.getUserInfo().member_type;
    let showHistory = false;
    if (
      member_type === "super" ||
      member_type === "system" ||
      member_type === "sysFive" ||
      member_type === "supFive"
    ) {
      showHistory = true;
    }
    return {
      member_type,
      loadScore: false,
      showClassDetail: false,
      showTeacherId:0,
      showHistory,
      c_id: this.$route.query.c_id,
      ops: ops(),
      disScrollOpt: ops(true),
      User,
      imgSrc: Img,
      ScheduleImg,
      scheduleFlag: false,
      classInfo: {},
      showData: false,
      isHighClass: false,
      scoreNum: {},
      student_data: [],
      student_achievement_file_data: [],
      make_up_student_data: [],
      semi_pass_student_data: [],
      isShowAuditScore: false,
      isShowClassInfo: false,
      isShowEditScore: false,
      isShowDownload: false,
      isShowScoreMsg: false,
      zonghe:false,
      isShowAppeal: 0,
      isShowComplaint: 0,
      isShowOther: 0,
      scoreMsg: [],
      assistant: {
        name: [],
        ids: [],
      },
      teacher_zhuli: {
        name: [],
        ids: [],
      },
      infoStatus:{
        refusedNum:0,
        passNum:0,
        auditNum:0,
        noActiveNum:0,
      },
      reportAssistant:[],
      verifyFlag: false,
      userInfo: this.$store.state.userInfo,
      classReportData: {},
      teaEvaData: [],
      studentFail: [],
      ifDiaShow: false,
      stuUid: "",
      add_show: false,
      certificateInfo:{
        name: '',
        certificate_number: '',
        uid: '',
        c_id: '',
        level: 'NF1-',
      },
    };
  },
  filters: {
    auditStatus(status){
      switch (status) {
        case 'edit' : status='待审核';break;
        case 'audit' : status='待审核';break;
        case 'pass' : status='通过';break;
        case 'refused' : status='退回修改';break;
        case 'revocation' : status='退回修改';break;
        default:status='未填写';break
      }
      return status
    },
    getGender(gender) {
      return gender === "Male" ? "男" : "女";
    },
    translate(str) {
      return filterHash[str];
    },
    transType(type,isFive) {
      if(isFive){
        return filterTypeFive[type];
      } else{
        return filterType[type];
      }
    },
    getScore(status) {
      switch (status) {
        case "pass":
          return "通过";
          break;
        case "practice_make_up":
          return "实践考试补考";
          break;
        case "fail":
          return "未通过";
          break;
        case "semi_pass":
          return "预通过";
          break;
      }
    },
    resLevel(val, isFive) {
      if (isFive) {
        const dic = {
          A: "A",
          B: "B",
          C: "C",
        };
        return dic[val];
      } else {
        return "";
      }
    },
    userRole: (role) => roleHash[role],
    tipMsg(is_score_unusual_stu, is_repetition_stu, is_not_score_stu) {
      let msg = "";
      if (is_score_unusual_stu == "1" && is_repetition_stu == "0") {
        msg = "成绩库中该学员上一级成绩异常";
        if (is_not_score_stu == "1") {
          msg = "成绩库中该学员上一级成绩异常";
        }
      }
      if (is_score_unusual_stu == "0" && is_repetition_stu == "1") {
        msg = "该学员重复参加此级别培训";
      }
      if (is_score_unusual_stu == "1" && is_repetition_stu == "1") {
        msg = "成绩库中该学员上一级成绩异常、重复参加此级别培训";
      }
      if (
        is_score_unusual_stu == "1" &&
        is_repetition_stu == "1" &&
        is_not_score_stu == "1"
      ) {
        msg = "成绩库中该学员上一级成绩异常、重复参加此级别培训";
      }
      return msg;
    },
  },
  components: {
    "score-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-status": () => import("@/components/Tips/Status"),
    "yioks-schedule": () => import("@/components/Timetable/Schedule"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-verify": () => import("@/components/Tips/verify-adjust-score"),
    "class-report-view": () =>
      import("@/components/score/components/class-report"),
    "teacher-eva-view": () =>
      import("@/components/score/components/teacher-eva"),
    "stu-detail-info": () => import("@/components/StuDeatilInfo/student-info"),
    "report-info-detail": () => import("@/components/score/components/class-report-assistant"),
    "add-dialog": () => import('@/components/score/components/upload-certificate'),
  },
  created() {
    this.getClassInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getClassInfo() {
      scoreDetail({ c_id: this.c_id })
        .then(({ data }) => {
          if (Number(data.status) === 0) {
            const {
              class_info,
              isShowAuditScore,
              isShowClassInfo,
              isShowEditScore,
              isShowDownload,
              isShowScoreMsg,
              score_msg_info,
              score_statistics,
              student_data,
              trainReport,
              teacher_eva_data,
              achievement_detail_data,
              studentFail,
              student_achievement_file_data,
              reportAssistant,
              isShowComplaint,
              isShowAppeal,
              isShowOther,
              affirmIds,
            } = data.result;
            // 2023-03-01 之前 叫综合平均成绩  之后 叫 综合成绩
            if(class_info.start_date < 1677600000000){
              this.zonghe= true;
            }
            this.student_achievement_file_data = student_achievement_file_data;
            let scoreArr = [];
            let affirmUserIds = [];
            if(affirmIds){
              affirmUserIds =affirmIds;
            }
            const stu_data = student_data.map((item) => {
              if((item.info_status === 'edit' || item.info_status === 'audit') && affirmUserIds.indexOf(item.stu_id) ===-1){
                this.infoStatus.auditNum = this.infoStatus.auditNum + 1;
              }
              if(item.info_status === 'refused' || item.info_status === 'revocation'){
                this.infoStatus.refusedNum = this.infoStatus.refusedNum + 1;
              }
              if(item.info_status === 'pass' || affirmUserIds.indexOf(item.stu_id) !==-1){
                this.infoStatus.passNum = this.infoStatus.passNum + 1;
              }
              if(!item.info_status){
                this.infoStatus.noActiveNum = this.infoStatus.noActiveNum + 1;
              }
              scoreArr = [];
              achievement_detail_data.map((e) => {
                if (item.achievement_id === e.achievement_id) {
                  scoreArr.push(e);
                }
              });
              return {
                ...item,
                scoreArr,
              };
            });
            const { class_level, class_train_type,class_the_quality } = class_info;
            if (
              (class_train_type === "train" || class_train_type === "physical_train") &&
              (class_level === "A" || class_level === "B" || class_level === "PRO" || class_level === "F1"|| class_level === "F2")
            ) {
              let make_up_list = [],
                default_list = [];
              stu_data.forEach((element) => {
                const { scoreArr } = element;
                const achievement_subject_id_list = [37, 44,53,204]; // 补考subject_id列表
                let make_up_flag = false; // 判断学员是否是补考学员
                scoreArr.forEach((item) => {
                  if (
                    item.achievement_subject_id &&
                    achievement_subject_id_list.includes(
                      item.achievement_subject_id
                    )
                  ) {
                    make_up_flag = true;
                  } else {
                    make_up_flag = false;
                  }
                });
                if (make_up_flag) {
                  make_up_list.push(element);
                } else {
                  default_list.push(element);
                }
              });
              this.student_data = default_list; // 设置正常培训学员
              this.make_up_student_data = make_up_list; // 设置补考学员名单
            } else if (class_the_quality === "futsal") {
              let semi_pass_list = [],
                default_list = [];
              stu_data.forEach((element) => {
                const { scoreArr } = element;
                const achievement_subject_id_list = [130, 131,132,133]; // 补考subject_id列表
                let make_up_flag = false; // 判断学员是否是补考学员
                scoreArr.forEach((item) => {
                  if (
                    item.achievement_subject_id &&
                    achievement_subject_id_list.includes(
                      item.achievement_subject_id
                    )
                  ) {
                    make_up_flag = true;
                  } else {
                    make_up_flag = false;
                  }
                });
                if (make_up_flag) {
                  semi_pass_list.push(element);
                } else {
                  default_list.push(element);
                }
              });
              this.student_data = default_list; // 设置正常培训学员
              this.semi_pass_student_data = semi_pass_list; // 设置补考学员名单
            } else{
              this.student_data = stu_data;
              this.make_up_student_data = [];
              this.semi_pass_student_data = [];
            }
            if (
              this.isFive &&
              student_achievement_file_data &&
              student_achievement_file_data.length
            ) {
              let _student_data = JSON.parse(JSON.stringify(this.student_data));
              student_achievement_file_data.forEach((item) => {
                _student_data.some((stuItem, i) => {
                  if (item.user_id === stuItem.stu_id) {
                    // stuItem.fileData = item;
                    stuItem.reason = item.reason || "";
                    stuItem.document_title = item.document_title || "";
                    stuItem.document_url = item.document_url || "";
                  }
                  return item.user_id === stuItem.user_id;
                });
              });
              this.student_data = _student_data;
            }
            this.classInfo = class_info;
            this.scoreNum = score_statistics;
            this.isShowAuditScore = Boolean(isShowAuditScore);
            this.isShowClassInfo = Boolean(isShowClassInfo);
            this.isShowEditScore = Boolean(isShowEditScore);
            this.isShowDownload = Boolean(isShowDownload);
            this.isShowScoreMsg = Boolean(isShowScoreMsg);
            this.isShowComplaint = isShowComplaint;
            this.isShowAppeal = isShowAppeal;
            this.isShowOther = isShowOther;
            isShowScoreMsg && (this.scoreMsg = score_msg_info);
            if (isShowClassInfo) {
              const nameArr =
                class_info.teacher_name && class_info.teacher_name.split(",");
              nameArr && this.$set(this.assistant, "name", nameArr);
              const idArr =
                class_info.teacher_ids && class_info.teacher_ids.split(",");
              idArr && this.$set(this.assistant, "ids", idArr);
              const nameArrZhuli =
                class_info.teacher_zhuli_names &&
                class_info.teacher_zhuli_names.split(",");
              nameArrZhuli && this.$set(this.teacher_zhuli, "name", nameArrZhuli);
              const idArrZhuli =
                class_info.teacher_zhuli_ids &&
                class_info.teacher_zhuli_ids.split(",");
              idArrZhuli && this.$set(this.teacher_zhuli, "ids", idArrZhuli);
            }
            this.reportAssistant = reportAssistant;
            this.classReportData = trainReport;
            if(teacher_eva_data){
              teacher_eva_data.map((item) => {
                if(item.has_eva || item.has_record){
                  this.teaEvaData.push(item);
                }
              })
            }
            
            this.studentFail = studentFail;
            if(['B','A','PRO','GB','GA','F1','F2'].includes(class_info.class_level)){
              this.isHighClass = true;
            }
            this.showData = true;
            
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    classImgError() {
      this.$set(this.classInfo, "moment_picture", this.imgSrc);
    },
    // 方法不茁壮啊
    userImgError(idx) {
      this.$set(this.student_data[idx], "profile_picture", this.User);
    },
    userImgErrorMakeUp(idx, list) {
      this.$set(list[idx], "profile_picture", this.User);
    },
    greetMoment() {
      this.$router.push({ path: "won", query: { c_id: this.classInfo.c_id } });
    },
    showSchedule() {
      this.scheduleFlag = true;
    },
    hideSchedule(bool) {
      this.scheduleFlag = bool;
    },
    lookTutorial(user_id) {
      /*if(this.userInfo.member_type === 'organ') {
          this.$router.push({
            path: "stu_tutorial",
            query: {
              user_id,
              c_id: this.c_id
            }
          });
        } else {
          this.$router.push({
            path: "stu_tutorial",
            query: {
              user_id,
              c_id: this.c_id
            }
          });
        }*/
      this.$router.push({
        path: "stu_tutorial",
        query: {
          user_id,
          c_id: this.c_id,
        },
      });
    },
    lookHistory(u_id) {
      this.$router.push({
        name: "sysTrainingHis",
        query: {
          u_id,
        },
      });
    },
    goConfirmInfo(){
      this.$router.push({
        path: "confirmInfoClass",
        query: {
          c_id: this.c_id,
        },
      });
    },
    lookTeaDetail(id) {
      this.$router.push({ path: "td", query: { id } });
    },
    lookOver(id) {
      // this.$router.push({path: 'od', query: {id: id}});
      this.$router.push({ path: "st", query: { id: id } });
    },
    lookClassDetail() {
      /* 系统管理员查看培训班信息 */
      this.$router.push({
        path: "class_detail",
        query: {
          c_id: this.c_id,
        },
      });
    },
    lookScore() {
      this.$router.push({
        path: "eva_class_detail",
        query: {
          id: this.c_id,
        },
      });
    },
    showfeeback(feedback_type,idx) {
      /* 系统管理员查看申述 */
      this.$router.push({
        path: "feedback",
        query: {
          c_id: this.c_id,
          org_id: this.classInfo.org_id,
          feedback_type: feedback_type,
          idx: idx,
        },
      });
    },
    editScore() {
      this.$router.push({
        path:
          this.classInfo.class_train_type === "train" || this.classInfo.class_train_type === "physical_train" || this.classInfo.class_train_type === "goalkeeper_train"
            ? "edit_score"
            : "edit_score_education",
        query: {
          c_id: this.c_id,
        },
      });
    },
    downScore() {
      if (this.loadScore) return;
      this.loadScore = true;
      scoreDownload({ c_id: this.c_id }).then(({ data }) => {
        if (data.status === 0) {
          downfile(data.result.file_url);
        } else {
          this.$message.error(`下载失败, ${data.msg}`);
        }
        this.loadScore = false;
      });
    },
    verifyScore() {
      this.verifyFlag = true;
    },
    hideVerifyDialog(bool, params, msg, isSendSms) {
      this.verifyFlag = false;
      if (bool) {
        classScoreVerify({
          c_id: this.c_id,
          status: params,
          msg_info: msg,
          isSendSms: isSendSms,
        })
          .then((res) => {
            const { status, msg } = res.data;
            if (Number(status) === 0) {
              this.getClassInfo();
              this.$message.success("审核成功");
            } else {
              this.$message.error(msg);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
      }
    },
    viewDetail(uid) {
      this.stuUid = uid;
      this.ifDiaShow = true;
    },
    addFunc(item,index) {
      this.$set(this.certificateInfo, "name", item.user_name);
      this.$set(this.certificateInfo, "uid", item.uid);
      this.$set(this.certificateInfo, "c_id", item.c_id);
      this.$set(this.certificateInfo, "certificate_number", item.certificate_number);
      this.$set(this.certificateInfo, "ducoment_file", item.ducoment_file);
      this.$set(this.certificateInfo, "ducoment_address", item.ducoment_address);
      this.$set(this.certificateInfo, "index", index);
      
      if(this.classInfo.class_level === 'L2'){
        this.$set(this.certificateInfo, "level", 'NF2-');
      }
      if(this.classInfo.class_level === 'L3'){
        this.$set(this.certificateInfo, "level", 'NF3-');
      }
      
      // 默认给年份带过去
      const year = new Date(this.classInfo.end_date).getFullYear();
      
      this.$set(this.certificateInfo, "year", year.toString().slice(2,4));
      this.add_show = true
    },
    hideAddDocumentTips(bool,flag){
      this.add_show = bool;
      if (flag){
//        this.student_data[index].certificate_number = info.certificate_number;
//        this.student_data[index].ducoment_address = info.ducoment_address;
//        this.student_data[index].ducoment_file = info.ducoment_file;
        this.getClassInfo();
        this.$message.success('信息保存成功')
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
buttons(flag)
  .btns
    if (flag)
      padding 0 30px 0 0
    flex 0 0 auto
    display flex
    align-items center
    .btn
      if (flag)
        margin 0 0 0 20px
        padding 10px 20px
      else
        margin 0 0 0 10px
        padding 6px 15px
      font-size $font_size_medium
      background-color $color_suc
      border 0
      cursor pointer
      user-select none
.scoreNav
  flex 1 1 auto
  display flex
  justify-content space-between
  align-items center
  padding 0 15px 0 0
  p
    font-size $font_size_big
  buttons(false)
.scoreMain
  width 100%
  height 100%
  .mainUp
    width 100%
    height 155px
    margin 0 0 10px
    display flex
    background-color $block_bg_color_base
    .upCommon
      padding 20px 0 20px 20px
      flex 1 1 auto
      display flex
      .imgWrap
        flex 0 0 auto
        position relative
        cursor pointer
        img
          width 150px
          height 115px
        .pos
          width 100%
          height 100%
          position absolute
          top 0
          left 0
          display flex
          flex-direction column
          user-select none
          .status
            margin 0 0 0 10px
          .btnWrap
            width 100%
            display flex
            justify-content center
            align-items center
            position absolute
            bottom 0
            .btn
              width 100px
              height 28px
              margin 0 0 1px
              display flex
              justify-content center
              align-items center
              background-color $color_err
      .details
        max-width 440px
        padding 0 0 0 15px
        flex 1 1 auto
        display flex
        flex-direction column
        justify-content space-between
        font-size $font_size_medium
        line-height $font_size_big
        p
          word-break break-all
        .teacherWrap
          display block
          .link
            color $color_suc
            cursor pointer
          .teacherName
            margin-right 15px
            flex none
        .service-item
          position relative
          cursor pointer
          margin-right 20px
          .item-common
            display none
            position absolute
            z-index 10000
            top -200px
            right -100px
            width 250px
            height 250px
            .content
              padding 10px
              justify-content center
              align-items center
              display flex
              background-color rgba(0, 0, 0, 0.7)
              img
                height 100%
                width 100%
                padding 5px
                border 1px solid #ffffff
          &:hover
            .qrCode
              display block
    .scheduleWrap
      width 269px
      height 147px
      padding 20px 30px 10px 0
      box-sizing border-box
      display flex
      justify-content center
      align-items center
      flex-direction column
      .edti_box
        width 100%
        border 1px dashed $color_white
        height 100%
        border-radius 5px
        margin-bottom 5px
        display flex
        justify-content center
        align-items center
        .btn
          width 80%
          height 40px
          display flex
          justify-content center
          align-items center
          font-size $font_size_medium
          cursor pointer
          margin 0 5px
          border-radius 5px
          background-color $color_suc
          border 0
          outline none
      .schedule
        width 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
        user-select none
        min-height 42px
        p
          margin 0 0 5px 0
          font-size 24px
        .btnWrap
          width 100%
          display flex
          border 1px dashed $color_white
          padding 5px 8px
          border-radius 5px
          p
            font-size 18px
            margin 0
            line-height 30px
          .btn
            width 55px
            height 30px
            display flex
            justify-content center
            align-items center
            font-size $font_size_medium
            cursor pointer
            margin 0 5px
            border-radius 5px
          .check
            background-color $color_suc
          .modify
            background-color $color_primary
          .download
            background-color $color_err
    buttons(true)
  .mainDown
    width 100%
    height calc(100% - 165px)
    padding 30px 0 25px 40px
    background-color $block_bg_color_base
    .contentWrap
      padding 0 30px 0 0
      .content
        .itemWrap
          margin 0 0 30px 0
          .titleWrap
            margin 0 0 20px 0
            display flex
            justify-content space-between
            font-size 20px
            user-select none
            align-items end
            .title
              display flex
              align-items center
              .logo
                margin 0 10px 0 0
              p
                line-height 20px
              .btn
                width auto
                cursor pointer
                height 28px
                margin-left 10px
                padding 13px
                display flex
                justify-content center
                align-items center
                background-color $color_suc
                font-size $font_size_medium
                border-radius 5px
          .info-view
            .table
              border 1px solid $color_white
              .report-row
                font-size $font_size_medium
                border-bottom 1px solid $color_white
                &:last-child
                  border-bottom none
                .report-col
                  padding 10px 20px
                  word-break break-all
                  /* &:first-child {
                    text-align: right;
                  } */
                  &:first-child
                    border-right 1px solid $color_white
                    /* border-right: 1px solid; */
                    margin-right -1px
                    margin-left -1px
                  /*&:nth-child(2)*/
                    /*border-left 1px solid $color_white*/
                    /* border-right: 1px solid; */
                    /* margin-left: -1px; */
          .scoreMsg
            display flex
            font-size $font_size_medium
            border 1px solid $color_white
            .item
              flex 1 1 auto
              padding 10px
              &:first-child
                width 33.3%
                border-right 1px solid $color_white
              &:last-child
                width 66.7%
                word-break break-all
          .totalScore
            display flex
            font-size $font_size_medium
            border 1px solid $color_white
            border-bottom none
            &:last-child
              border-bottom 1px solid $color_white
            .item
              width 33.3%
              padding 10px
              flex 1 1 auto
              border-right 1px solid $color_white
              &:last-child
                border-right none
          .table
            .item
              margin 0 0 20px 0
              border 1px solid $color_white
              .row
                display flex
                .col
                  flex 1 1 auto
                  border-right 1px solid $color_white
                  &:last-child
                    border-right none
                &.up
                  // height: 80px;
                  .col
                    // height: 100%;
                    &.user
                      width 25%
                      display flex
                      justify-content center
                      align-items center
                      padding-left 8px
                      .imgWrap
                        cursor pointer
                        flex none
                      img
                        flex 0 0 auto
                        width 60px
                        height 60px
                        border-radius 50%
                      .wrap
                        // height: 100%;
                        margin 0 0 0 12px
                        display flex
                        flex-direction column
                        justify-content space-around
                        align-items center
                        width 100%
                        .name
                          font-size $font_size_medium
                          // word-break break-word
                          word-break break-all
                          word-wrap break-word
                          margin-bottom 5px
                          width 100%
                          text-align center
                        .btn
                          padding 5px 15px
                          background-color $color_suc
                          border-radius 5px
                          cursor pointer
                          user-select none
                        .nonePlan{
                          padding: 5px 15px;
                          background-color: $color_background_grey;
                          border-radius: 5px;
                          cursor: not-allowed;
                          user-select: none;
                        }
                        .btn_route
                          display flex
                          .route
                            color $color_suc
                            cursor pointer
                          .split
                            color $color_suc
                            margin 0 5px
                    title()
                      flex 0 0 auto
                      width 30px
                      // height: 100%;
                      display flex
                      flex-direction column
                      justify-content center
                      align-items center
                      border-right 1px solid $color_white
                    &.info
                      width 35%
                      display flex
                      .title
                        title()
                      .block
                        flex 1 1 auto
                        display flex
                        flex-direction column
                        .line
                          flex 1 1 auto
                          /* padding: 0 0 0 20px; */
                          /* padding: 0 0 0 2px */
                          display flex
                          align-items center
                          font-size $font_size_base
                          border-bottom 1px solid $color_white
                          &:last-child
                            border-bottom none
                          span:first-child
                            margin 0 5px 0 0
                    &.note
                      width 25%
                      display flex
                      align-items center
                      .title
                        title()
                        align-self stretch
                      textarea
                        flex 1 1 auto
                        margin 0 10px
                        color $color_black
                        resize none
                    &.average
                      width 15%
                      display flex
                      align-items center
                      .title
                        title()
                        width 45px
                      .score
                        flex 1 1 auto
                        text-align center
                    &.grade
                      width 17%
                      display flex
                      align-items center
                      .title
                        title()
                        align-self stretch
                      .gradeStatus
                        flex 1 1 auto
                        display flex
                        justify-content center
                        align-items center
                        font-size $font_size_medium
                        p
                          text-align center
                &.down
                  height 60px
                  border-top 1px solid $color_white
                  .col
                    width 25%
                    display flex
                    flex-direction column
                    justify-content space-around
                    align-items center
                    font-size $font_size_small
            .repetition_stu
              border 1px solid $color_tip_red
            .unusual_err_stu
              border 1px solid $color_unusual
            .both_err_stu
              border 1px solid $color_both_err
        .timeline
          display block
          padding-left 3px
          .timeline-item
            position relative
            padding-bottom 20px
            .item_tail
              position absolute
              top 36px
              bottom 6px
              left 16px
              // height 100%
              border-left 2px solid #cccccc
            .item_node
              position absolute
              background-color #fff
              color #333
              border 1px solid #fff
              border-radius 50%
              // left -2px
              width 36px
              height @width
              font-size 12px
              display flex
              align-items center
              text-align center
              justify-content center
            .item_wrap
              position relative
              padding-left 50px
              top -3px
              .timestamp
                display flex
                // align-items center
                line-height 1
                margin-bottom 5px
                font-size 15px
                .audit_people
                  flex 1
                  text-align right
                  margin-left 10px
              .item_cont
                display block
                background-color #fff
                color #333
                padding 10px
                border-radius 4px
                border 1px solid #cccccc
                overflow hidden
                font-size 15px
                box-shadow 0 2px 12px 0 rgba(255, 255, 255, 0.1)
  .detail-info-dia
    .scroll-wrap
      display block
      height 530px
      overflow hidden
      position relative
      .stu-info-box
        display block
        padding 0 15px
        font-size $font_size_medium
.flex-wrapper
  flex 1
  display flex
  align-items center
  justify-content flex-start
  width 818px
  overflow hidden
  padding 0 10px
  box-sizing border-box
.link-doc
  cursor pointer
  user-select none
  &.suc
    color $color_suc
</style>
